import { render, staticRenderFns } from "./sidePanels.vue?vue&type=template&id=748c97e6&scoped=true"
import script from "./sidePanels.vue?vue&type=script&lang=js"
export * from "./sidePanels.vue?vue&type=script&lang=js"
import style0 from "./sidePanels.vue?vue&type=style&index=0&id=748c97e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748c97e6",
  null
  
)

export default component.exports